import styled from 'styled-components';
import { colors } from 'Theme';
import { asRem } from 'utils';
import { thumbSdaImage, thumbResilienzImage } from 'images/landingpages/cooperation_page';

export default styled.div`
  width: ${asRem(384)};
  min-height: ${asRem(144)};
  margin-bottom: ${asRem(16)};
  text-align: left;

  .mime-elements-link,
  .mime-elements-link:visited,
  .mime-elements-link:focus,
  .mime-elements-link:hover,
  .mime-elements-link:active {
    text-decoration: none !important;

    > *,
    * {
      color: ${(props) => props.theme.colors.white.c500} !important;
      text-decoration: none !important;
    }
  }

  .box-frame {
    margin-top: ${asRem(14)};
    border-radius: ${asRem(8)};
    padding: ${asRem(24)};
    min-height: ${asRem(128)};
    position: relative;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    &:after {
      content: '';
      background-repeat: no-repeat;
      background-size: contain;
      width: ${asRem(134)};
      height: ${asRem(80)};
      position: absolute;
      right: 0;
      top: -${asRem(42)};
    }
  }

  .mime-elements-headline-4 {
    text-align: left;
    margin-top: 0;
  }

  &.sda-tile .box-frame {
    background-color: ${colors.pink.c500};

    &:hover,
    &:active {
      transform: scale(1.02);
      box-shadow: 0 ${asRem(4)} ${asRem(12)} ${colors.black.o30};
    }

    &:after {
      background-image: url(${thumbSdaImage});
    }
  }

  &.resilienz-tile .box-frame {
    background-color: ${colors.blue.c500};

    &:hover,
    &:active {
      transform: scale(1.02);
      box-shadow: 0 ${asRem(4)} ${asRem(12)} ${colors.black.o30};
    }

    &:after {
      background-image: url(${thumbResilienzImage});
      width: ${asRem(140)};
      height: ${asRem(102)};
    }
  }

  button.mime-elements-button {
    margin-bottom: 0;
  }
`;
